import React from 'react';
import PropTypes from 'prop-types';
import DataContainer from 'Components/UI/DataContainer';
import useRelationship from 'Hooks/useRelationship';
import {
  EstatePlanStatusOptions,
} from 'Components/Flyouts/HouseholdInfo/Sections/Service/HouseholdSectionServicePicker/HouseholdSectionService/EstatePlanStatusOptions/EstatePlanStatusOptions';

const EstatePlanStatusOptionsContainer = ({ estatePlanningStatusRelationship }) => {
  const {
    loading,
    loadingError,
    collection,
  } = useRelationship(estatePlanningStatusRelationship);

  return (
    <DataContainer
      loading={loading}
      loadingError={loadingError}
      component={EstatePlanStatusOptions}
      componentProps={{
        estatePlanningStatusResource: collection?.resources().head(),
      }}
    />
  );
};

EstatePlanStatusOptionsContainer.defaultProps = {};

EstatePlanStatusOptionsContainer.propTypes = {
  estatePlanningStatusRelationship: PropTypes.object.isRequired,
};

export { EstatePlanStatusOptionsContainer };
